import { createColumnHelper } from "@tanstack/react-table";
import { Flex } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { ReceivedEmailMessagesOrderBy } from "__generated__/gql/graphql";
import AutoTooltipIcon from "components/Shared/AutoTooltipIcon";
import { GQLOrderByEnumsById } from "components/Shared/ChakraReactTable/useGQLSorting";
import EmptyPlaceholder from "components/Shared/EmptyPlaceholder";
import ReceivedEmailCategoryTag from "components/Shared/ReceivedEmailCategoryTag";
import { BASE_ORDER_BY } from "./EmailTable";

const fragment = gql(/* GraphQL */ `
  fragment EmailTableCategoryColumn on ReceivedEmailMessage {
    receivedEmailMessageCategory {
      receivedEmailMessageId
      category
      isAutoAssociated
    }
  }
`);

export type EmailTableCategoryColumnRow = FragmentType<typeof fragment>;

function fromFragment(row: EmailTableCategoryColumnRow) {
  return getFragmentData(fragment, row);
}

const CATEGORY_TAG_PROPS = { size: "sm" } as const;
const col = createColumnHelper<EmailTableCategoryColumnRow>();

export const RECEIVED_EMAIL_CATEGORY_ORDER_BY: GQLOrderByEnumsById<ReceivedEmailMessagesOrderBy> =
  {
    ...BASE_ORDER_BY,
    category: [
      ReceivedEmailMessagesOrderBy.RECEIVED_EMAIL_MESSAGE_CATEGORY__CATEGORY_ASC,
      ReceivedEmailMessagesOrderBy.RECEIVED_EMAIL_MESSAGE_CATEGORY__CATEGORY_DESC,
    ],
  };

export const RECEIVED_EMAIL_CATEGORY_COLUMN = col.accessor(
  (r) => fromFragment(r).receivedEmailMessageCategory?.category,
  {
    id: "category",
    header: "Category",
    cell: (cell) => {
      const category = fromFragment(
        cell.row.original,
      ).receivedEmailMessageCategory;

      if (!category?.category)
        return <EmptyPlaceholder>Uncategorized</EmptyPlaceholder>;

      return (
        <Flex alignItems="baseline" gap={1}>
          <ReceivedEmailCategoryTag
            category={category.category}
            {...CATEGORY_TAG_PROPS}
          />
          {category.isAutoAssociated && (
            <AutoTooltipIcon label="Category automatically associated using email address" />
          )}
        </Flex>
      );
    },
    size: 150,
  },
);
